import { useEffect } from 'react';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { toPoint } from '../../../../utils';
import { getDraftRoute } from '../../draft/route/selectors';
import { getDraftTariff } from '../../draft/tariff/selectors';
import { comparePoint, memoize } from '../../utils';
import { getZoneName, getZonePoint } from '../../zone/selectors';
import { createAsyncState } from '../hooks';
var memoSourcePoint = memoize(function (route) {
    var _a, _b, _c;
    return toPoint((_c = (_b = (_a = route[0]) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.geoObject) === null || _c === void 0 ? void 0 : _c.pos);
}, comparePoint);
var usePreOrderAsync = createAsyncState('preOrder');
export var usePreOrderQuery = function () {
    var _a = usePreOrderAsync(), asyncState = _a[0], actions = _a[1];
    var state = useStoreContext()[0];
    var preOrder = useAPIContext().preOrder;
    var zoneName = getZoneName(state);
    var tariff = getDraftTariff(state);
    var sourcePoint = memoSourcePoint(getDraftRoute(state));
    var zonePoint = getZonePoint(state);
    // как оказалось, для запроса в ручку предзаказа достаточно точки А, либо координат зоны
    // то есть весь маршрут передавать не нужно
    var point = sourcePoint || zonePoint;
    useEffect(function () {
        if (preOrder && point && zoneName && tariff) {
            actions.start();
            return preOrder({
                body: {
                    classes: [tariff],
                    route: [point],
                    zone_name: zoneName,
                },
                onSuccess: actions.success,
                onError: actions.error,
            });
        }
    }, [actions, point, preOrder, tariff, zoneName]);
    return asyncState;
};
export var usePreOrderState = function () { return usePreOrderAsync()[0]; };
